import { render, staticRenderFns } from "./LoginSecurity.vue?vue&type=template&id=4ba8affa&scoped=true"
import script from "./LoginSecurity.vue?vue&type=script&lang=js"
export * from "./LoginSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba8affa",
  null
  
)

export default component.exports